let state = {
  pageName: '', // 页面名称
  remind: false, // 不勾选同意协议的复选框
  isShow: false, // 通讯录弹窗关闭
  dialogVisible: false, // 协议框关闭
  isTrue: false // 不点击协议框确认按钮
}

const getters = {
  pageName: state => {
    return state.pageName
  },
  remind: state => {
    return state.remind
  },
  isShow: state => {
    return state.isShow
  },
  dialogVisible: state => {
    return state.dialogVisible
  },
  isTrue: state => {
    return state.isTrue
  }
}

const mutations = {
  changePageName: (state, pageName) => {
    state.pageName = pageName
  },
  changeRemind: (state, remind) => {
    state.remind = remind
  },
  changeIsShow: (state, isShow) => {
    state.isShow = isShow
  },
  changeDialogVisible: (state, dialogVisible) => {
    state.dialogVisible = dialogVisible
  },
  changeIsTrue: (state, isTrue) => {
    state.isTrue = isTrue
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/confirmDialog.js